<ng-container *transloco="let t">
  @for (error of errors(); track error.kind) {
  <span class="text-xs text-danger" [class]="appliedClasses()"> {{ t(`${error.message}`) }} </span>
  }
</ng-container>
